import { render, staticRenderFns } from "./view-forex.vue?vue&type=template&id=62357df8&scoped=true&"
import script from "./view-forex.vue?vue&type=script&lang=js&"
export * from "./view-forex.vue?vue&type=script&lang=js&"
import style0 from "./view-forex.vue?vue&type=style&index=0&id=62357df8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62357df8",
  null
  
)

export default component.exports